module.exports = "https://static.wagwalking.com/_next/static/images/local-expert-mobile-1006d5462bab8f9dcc1dc0c8190c6347.webp";